import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import UsersTable from './UsersTable';

import Collapsible from '../util/Collapsible';

const UsersOverview = ({ scrollTop, defaultOpen }) => (
  <Collapsible headerContent="Users" defaultOpen={defaultOpen}>
    <UsersTable scrollTop={scrollTop} />
  </Collapsible>
);

UsersOverview.propTypes = {
  scrollTop: PropTypes.func.isRequired,
};

export default connect(
  ({
    users: {
      editing: { editType },
    },
  }) => ({
    defaultOpen: editType === 'NONE' || editType === 'USER',
  })
)(UsersOverview);
